export default __webpack_public_path__ + "static/5-7aeedd705514600f10c974bc1d74f436.woff";